<script>
  import { Route } from 'svelte-router-spa';
  export let currentRoute;
  export let params;

  import Navbar from '../../../components/navbar/Navbar.svelte';
  import Customers from '../../../components/home/Customers.svelte';
  import Search from '../../../components/home/Search.svelte';
  import AddUserButton from '../../../components/home/AddUserButton.svelte';
</script>

<svelte:head>
  <title>Anasayfa</title>
</svelte:head>

<div>
  <Navbar />
  <AddUserButton />
  <Search />
  <Customers />
  <Route {currentRoute} {params} />
</div>
